// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { AbstractModuleUi } from '../_abstract/ui';
import { ModuleDriver } from '../_contracts';
import { HeadingNavModuleUi } from '../HeadingNav/HeadingNav.ui';
import { Editor } from './_partials';
/**
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
let AuthorCardModuleUi = class AuthorCardModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        this.author = null;
    }
    get navModule() {
        if (!this.author) {
            return null;
        }
        const content = {
            heading: '',
            headingType: 'h2',
            menuVariant: 'medium',
            menu: [
                {
                    label: this.$t('modules.author.about'),
                    url: '/o-nas-',
                    newWindow: false
                },
                {
                    label: `${this.author.firstName} ${this.author.lastName}`,
                    url: null,
                    newWindow: false
                }
            ]
        };
        return {
            content,
            driver: ModuleDriver.HeadingNav,
            id: 'author-nav',
            title: 'Author Navigation',
            isLazyLoaded: false,
            isVisible: true,
            isMobileVisible: true,
            isDesktopVisible: true,
            size: {
                colSpan: 12,
                rowSpan: 1,
                minColSpan: 1,
                minRowSpan: 1,
                isResizable: false
            }
        };
    }
    async fetchRelated() {
        try {
            const author = await this.relatedService.resolve(this.module.content.authorRelated);
            if (author.isPageActive) {
                this.author = author;
            }
            else {
                this.onError(new Error('Author page does not exist'));
            }
        }
        catch (error) {
            this.onError(error);
        }
    }
};
AuthorCardModuleUi = __decorate([
    Component({
        name: 'AuthorCardModuleUi',
        components: { Editor, HeadingNavModuleUi },
        async created() {
            await this.fetchRelated();
        },
        template: `
    <div class="author-view">
      <HeadingNavModuleUi v-if="module.content.canShowHeader && navModule" :module="navModule" class="mb-5" />

      <Editor v-if="author" :editor="author" :showAbout="module.content.showAbout" :isLazy="module.isLazyLoaded"
              nameTag="h1" class="author-view__author pb-md-6 border-bottom"/>

      <div v-if="!module.content.showAbout" class="row justify-content-center justify-content-lg-start">
        <div v-if="author" v-html="author.description" class="col-12 col-lg-8 my-5 my-md-6 fs-medium"/>
      </div>
    </div>
  `
    })
], AuthorCardModuleUi);
export { AuthorCardModuleUi };
export default AuthorCardModuleUi;
